import { z } from "zod";

const gemProfileSchema = z.object({
  rank: z.string(),
  change_24h: z.number(),
  gem_amount: z.number(),
  daily_percentage: z.number(),
});

type GemProfile = z.infer<typeof gemProfileSchema>;

export { gemProfileSchema, type GemProfile };
